
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const { t } = useTranslation();
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20showroom%20with%20European%20luxury%20brands%20displayed%20in%20clean%20white%20space%2C%20professional%20lighting%2C%20modern%20architecture%2C%20sophisticated%20retail%20environment%2C%20high-end%20fashion%20boutique%20interior%2C%20clean%20lines%20and%20premium%20materials&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          {t('heroTitle')}
        </h1>
        
        <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto font-light">
          {t('heroSubtitle')}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            variant="primary" 
            size="lg"
            onClick={() => scrollToSection('about')}
            className="bg-black text-white hover:bg-gray-800"
          >
            {t('aboutUs')}
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => scrollToSection('services')}
            className="border-white text-white hover:bg-white hover:text-black"
          >
            {t('services')}
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => scrollToSection('brands')}
            className="border-white text-white hover:bg-white hover:text-black"
          >
            {t('brands')}
          </Button>
          <Button 
            variant="primary" 
            size="lg"
            onClick={() => scrollToSection('contact')}
            className="bg-amber-600 text-white hover:bg-amber-700"
          >
            {t('contact')}
          </Button>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('about')}
          className="w-8 h-8 flex items-center justify-center text-white cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
